var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-info-container"},[_c('ps-info',{attrs:{"items":_vm.items,"size":_vm.large ? "l" : "s","hide-link":_vm.large ? true : false},on:{"goToList":_vm.goToInfoPage,"clickItem":_vm.clickItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }